import React from 'react';
import { FormattedMessage } from 'react-intl';
import { jsx as ___EmotionJSX } from "@emotion/react";
const OpeningPeriods = _ref => {
  let {
    openingPeriods
  } = _ref;
  const dayEnum = {
    '0': 'Info',
    '1': 'Montag',
    '2': 'Mo - Mi',
    '3': 'Mo - Do',
    '4': 'Mo - Fr',
    '5': 'Dienstag',
    '6': 'Di - Fr',
    '7': 'Mittwoch',
    '8': 'Donnerstag',
    '9': 'Freitag',
    '10': 'Samstag',
    '11': 'Sonntag',
    '12': 'Mo - Di',
    '13': 'Do - Fr',
    '14': 'Mo, Mi, Fr',
    '15': 'Heiligabend',
    '16': 'Silvester'
  };
  let sortedPeriods = {};
  openingPeriods.forEach(period => {
    if (period.day !== '0') {
      if (period.time_open && period.time_close) {
        if (sortedPeriods[period.day]) {
          sortedPeriods[period.day].times.push(period.time_open, period.time_close);
        } else {
          sortedPeriods[period.day] = {
            day: period.day,
            times: [period.time_open, period.time_close],
            sort: period.sort
          };
        }
      } else {
        sortedPeriods[period.day] = {
          day: period.day,
          closed: true,
          sort: period.sort
        };
      }
    }
  });
  let array = [];
  Object.keys(sortedPeriods).forEach(period => array.push(sortedPeriods[period]));
  const sortedArray = array.sort((a, b) => a.sort - b.sort);
  //console.log(sortedPeriods.sort((a, b) => a.sort - b.sort));
  const freeText = openingPeriods.find(period => period.free_text);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h4", null, "\xD6ffnungszeiten"), ___EmotionJSX("ul", null, sortedArray.map(period => {
    const custom = !Object.keys(dayEnum).find(d => d === period.day);
    return ___EmotionJSX("li", {
      key: period.day,
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, ___EmotionJSX("span", {
      style: {
        marginRight: '5px'
      }
    }, custom ? period.day : dayEnum[period.day]), period.closed ? ___EmotionJSX(FormattedMessage, {
      id: "components.widgets.openingHoursWidget.closed"
    }) : ___EmotionJSX("span", null, period.times.map((time, i) => {
      return ___EmotionJSX(React.Fragment, {
        key: time + i
      }, ___EmotionJSX("time", null, time.substring(0, time.length - 3)), i % 2 ? null : ' - ', i % 2 ? ___EmotionJSX("br", null) : null);
    })));
  }), freeText ? ___EmotionJSX("li", {
    className: "int-free-text",
    style: {
      display: 'flex'
    }
  }, freeText.free_text) : null));
};
export default OpeningPeriods;